export const DEFAULT_FILTER_LABEL = 'Filter by date';
export const DATE_FORMAT_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};
